import { Tags } from '../../../packages/Tags';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch, useFilterChangeCallback } from 'shared/hooks';
import { selectTags, selectTagsToReset } from 'shared/selectors/tags';
import { ITagOption } from '@cian/ui-kit';
import { removeTag } from 'shared/thunks/tags';
import { setTags } from 'shared/slices/tags';

export const TagsContainer: FC = () => {
  const dispatch = useAppDispatch();
  const tags = useSelector(selectTags);
  const tagsToReset = useSelector(selectTagsToReset);

  const onTagDeleted = useCallback(
    (tag: ITagOption) => {
      dispatch(removeTag(tag));
    },
    [dispatch],
  );

  const onChange = useFilterChangeCallback('geo');

  const onAllTagsDeleted = useCallback(() => {
    dispatch(setTags([]));
    onChange({ action: 'clearTags', arguments: [tagsToReset] });
  }, [dispatch, onChange, tagsToReset]);

  return <Tags tags={tags} onTagDeleted={onTagDeleted} onAllTagsDeleted={onAllTagsDeleted} />;
};
